import type { MenuItem } from '../types/menu-item'
import { isMenuLink } from './is-menu-link'

export const hasRenderableMenuItem = (items: MenuItem[]): boolean => {
  return items.some(item =>
    isMenuLink(item) ? item.shouldRender : hasRenderableMenuItem(item.dropdownItems),
  )
}
